import React from 'react';

import OrderDetails from 'components/sections/order-details';

const Order = props => (
  <OrderDetails {...props} />
);

export default Order;
